import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Please Enter Name"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please Enter Email"),
    phone_number: Yup.string()
    .matches(/^(\+91[\-\s]?)?[0]?(91)?[6-9]\d{9}$/, 'Must be a valid Indian mobile number')
    .required('Mobile number is required')
  }),
  mapPropsToValues: props => ({
    name: "",
    email: "",
    phone_number: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
